import { gql } from '@apollo/client'

export const GET_COMPANY_NOTIFICATIONS = gql`
  query getCompanyNotifications {
    listCompanyWorkspaces(isActive: true) {
      data {
        accessPermissionRequests {
          id
          status
        }
      }
    }
  }
`

export const GET_USERS_INVITED_STATUS = gql`
  query getUsersInvitedStatus($companyId: String!, $brandId: String!, $status: InviteStatus!) {
    getUsersInvitedStatus(companyId: $companyId, brandId: $brandId, status: $status) {
      brandId
      companyId
      email
      id
      role
      status
      workspaceName
    }
  }
`

export const GET_COMPANY = gql`
  query getCompany($companyId: String!) {
    getCompany(companyId: $companyId) {
      ... on CompanyBasic {
        id
        usersCount {
          editors
          viewers
        }
      }
    }
  }
`

export const LIST_COMPANY_WORKSPACE_REQUESTS = gql`
  query listCompanyWorkspaceRequests {
    listCompanyWorkspaces(isActive: true) {
      data {
        name
        accessPermissionRequests {
          id
          email
          workspaceId
          status
          createdAt
          updatedAt
        }
      }
    }
  }
`

export const INVITE_USER = gql`
  mutation inviteUser($emails: [String!], $brandIds: [String!], $role: Int!, $language: String) {
    inviteUser(emails: $emails, brandIds: $brandIds, role: $role, language: $language) {
      success
      message
    }
  }
`

export const CREATE_INVITE_LINK = gql`
  mutation createInviteLink($role: Int!) {
    createInviteLink(role: $role) {
      ... on InviteLink {
        link
      }
      ... on StatusMessage {
        success
        code
        title
        message
      }
    }
  }
`

export const CANCEL_USER_INVITATION = gql`
  mutation cancelUserInvitation($workspaceId: String!, $email: String!) {
    cancelUserInvitation(workspaceId: $workspaceId, email: $email) {
      message
      success
    }
  }
`

export const REGISTER_USER_BY_REQUEST = gql`
  mutation registerUserByRequest($requestId: String!, $role: Int!) {
    createUserOnCompanyWorkspaceByRequest(
      createUserOnCompanyWorkspaceByRequestInput: { requestId: $requestId, role: $role }
    ) {
      success
      message
    }
  }
`

export const DENY_USER_REQUEST = gql`
  mutation denyUserRequest($requestId: String!) {
    denyUserWorkspaceAccessRequest(workspaceAccessRequestId: $requestId) {
      success
      message
    }
  }
`

export const GET_ZAI_HERO_BRAND = gql`
  query getZaiHeroBrand {
    listBrandOwnersAndCompetitorsByWorkspace {
      data {
        brand {
          id
          name
          color
          isVerified
        }
        type
      }
    }
  }
`

export const GET_WORKSPACE_MACRO_INDUSTRY = gql`
  query getWorkspaceMacroIndustry {
    getWorkspaceMacroIndustry {
      workspaceId
      territoryId
      name
    }
  }
`
